module.exports = __webpack_public_path__ + "img/CZ60197609.23e8e876.jpeg";